import {clsx} from 'clsx'

import {ThemeProvider} from '@primer/react-brand/esm'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import {useContentfulData} from '@github-ui/swp-core/lib/hooks/use-contentful-data'
import {toPayload} from '../../../lib/types/payload'
import {toBrandPage, type GenericSection} from '../../../brand/lib/types/contentful'
import {sanitizePricingSectionData} from './utils/contentful'

import Hero from './components/sections/Hero/Hero'
import Features from './components/sections/Features/Features'
import CtaBanner from './components/sections/CtaBanner/CtaBanner'
import Faq from './components/sections/Faq/Faq'

import SecurityStyles from './../_styles/shared.module.css'
import GlobalStyles from './styles/global.module.css'

export default function SecurityPlansIndex() {
  const {contentfulRawJsonResponse} = toPayload(useRoutePayload<unknown>())
  const contentfulResponse = useContentfulData(contentfulRawJsonResponse)
  const page = toBrandPage(contentfulResponse)

  const {template} = page.fields
  const {subnav} = template.fields
  const {
    securityPlansHeroSection: heroSection,
    securityPlansPricingSection: pricingSection,
    securityPlansFAQSection: faqSection,
  } = page.ids

  const heroComponent = heroSection?.fields.content?.find(item => item.sys.contentType.sys.id === 'primerComponentHero')
  const pricingOptionsComponent = heroSection?.fields.content?.find(
    item => item.sys.contentType.sys.id === 'primerComponentPricingOptions',
  )
  const pricingSectionData = sanitizePricingSectionData(pricingSection as GenericSection)
  const {pricingTable, ctaBanner} = pricingSectionData || {}

  const faqGroupComponent = faqSection?.fields.content?.find(
    item => item.sys.contentType.sys.id === 'primerComponentFaqGroup',
  )

  return (
    <ThemeProvider
      colorMode="dark"
      className={clsx(SecurityStyles.root, SecurityStyles.fontSmoothing, GlobalStyles.root)}
    >
      {heroComponent && pricingOptionsComponent ? (
        <Hero subnav={subnav} contentfulContent={heroComponent} pricingOptions={pricingOptionsComponent} />
      ) : null}

      {pricingTable?.length ? <Features categories={pricingTable} /> : null}

      {ctaBanner ? <CtaBanner contentfulContent={ctaBanner} /> : null}

      {faqGroupComponent ? <Faq contentfulContent={faqGroupComponent} /> : null}
    </ThemeProvider>
  )
}
